import { Link, useNavigate } from 'react-router-dom'
import { useOrdersList } from '../lib/useOrdersList'
import { STATUS_LABELS, ACTIVE_ORDER_STATUSES } from '../types'
import type { OrderStatus } from '../types'
import { FlagStrip } from '../components/FlagStrip'

export default function OrdersPage() {
  const { orders, loading, error, statusFilter, setStatusFilter, search, setSearch, page, setPage, totalPages } = useOrdersList()
  const navigate = useNavigate()

  return (
    <div>
      <h1 style={{ marginBottom: 20 }}>Aufträge</h1>

      <div style={{ display: 'flex', gap: 10, marginBottom: 16, alignItems: 'center' }}>
        <input
          type="search"
          placeholder="Referenz, Kunde suchen…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1) }}
          style={{ width: 300 }}
        />
        <select
          value={statusFilter}
          onChange={(e) => { setStatusFilter(e.target.value as OrderStatus | ''); setPage(1) }}
          style={{ width: 180 }}
        >
          <option value="">Alle</option>
          {ACTIVE_ORDER_STATUSES.map((s) => (
            <option key={s} value={s}>{STATUS_LABELS[s]}</option>
          ))}
        </select>
        <Link to="/orders/new" className="btn btn-primary">+ Neuer Auftrag</Link>
      </div>

      {error && (
        <div className="error-msg" style={{ marginBottom: 16 }}>
          Fehler beim Laden der Aufträge: {error}
        </div>
      )}

      <div className="card" style={{ padding: 0 }}>
        {loading ? (
          <div className="loading">Aufträge werden geladen…</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Referenz</th>
                <th>Kunde</th>
                <th>Flaggen</th>
                <th>Status</th>
                <th>Aktualisiert</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--color-muted)' }}>Keine Aufträge gefunden</td></tr>
              )}
              {orders.map((o) => (
                <tr
                  key={o.id}
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate(`/orders/${o.id}`)}
                >
                  <td><Link to={`/orders/${o.id}`} onClick={(e) => e.stopPropagation()}>{o.reference}</Link></td>
                  <td>{o.client_name}<br /><small style={{ color: 'var(--color-muted)' }}>{o.client_email}</small></td>
                  <td><FlagStrip flags={o.flags} /></td>
                  <td><span className={`badge badge-${o.status}`}>{STATUS_LABELS[o.status]}</span></td>
                  <td>{new Date(o.updated_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'center' }}>
          <button className="btn btn-secondary" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>← Zurück</button>
          <span style={{ alignSelf: 'center', color: 'var(--color-muted)' }}>Seite {page} / {totalPages}</span>
          <button className="btn btn-secondary" disabled={page >= totalPages} onClick={() => setPage(p => p + 1)}>Weiter →</button>
        </div>
      )}
    </div>
  )
}
